import { Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WorkOutlineIcon from "@mui/icons-material/WorkOutline";
import StarRateIcon from "@mui/icons-material/StarRate";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import { motion } from "framer-motion";
import StyleDocDetail from "../docdetail.module.css";

const Experience = ({ doctor }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <Typography
        variant="h5"
        gutterBottom
        style={{ color: "royalblue", marginBottom: "0.5rem" }}
      >
        Professional Experience
      </Typography>

      <Typography
        variant="body1"
        paragraph
        style={{ color: "#555", fontSize: "1rem" }}
      >
        {doctor.experience}
      </Typography>

      <Typography variant="h6" style={{ color: "#444", marginTop: "1rem" }}>
        Career Highlights
      </Typography>

      <div>
        <div className={StyleDocDetail.highlight}>
          <WorkOutlineIcon style={{ color: "#007ACC" }} />
          <Typography
            variant="body2"
            style={{ color: "#555", marginLeft: "0.5rem" }}
          >
            Over 15 years of clinical and surgical experience
          </Typography>
        </div>

        <div className={StyleDocDetail.highlight}>
          <StarRateIcon style={{ color: "#FF9800" }} />
          <Typography
            variant="body2"
            style={{ color: "#555", marginLeft: "0.5rem" }}
          >
            Patient-first approach
          </Typography>
        </div>

        <div className={StyleDocDetail.highlight}>
          <EmojiEventsIcon style={{ color: "#4CAF50" }} />
          <Typography
            variant="body2"
            style={{ color: "#555", marginLeft: "0.5rem" }}
          >
            Recipient of multiple excellence awards
          </Typography>
        </div>

        <div className={StyleDocDetail.highlight}>
          <CheckCircleIcon style={{ color: "#9C27B0" }} />
          <Typography
            variant="body2"
            style={{ color: "#555", marginLeft: "0.5rem" }}
          >
            Regular contributor to international medical journals
          </Typography>
        </div>
      </div>

      {/* <List style={{padding: "0", backgroundColor: "#f9f9f9", borderRadius: "8px"}}>
        <ListItem>
          <ListItemIcon>
            <WorkOutlineIcon style={{ color: "#007ACC" }} />
          </ListItemIcon>
          
          <ListItemText
            primary="Over 15 years of clinical and surgical experience"
          />
        </ListItem>

        <ListItem>
          <ListItemIcon>
            <StarRateIcon style={{ color: "#FF9800" }} />
          </ListItemIcon>
          <ListItemText
            primary="Patient-first approach"
          />
        </ListItem>

        <ListItem>
          <ListItemIcon>
            <EmojiEventsIcon style={{ color: "#4CAF50" }} />
          </ListItemIcon>
          <ListItemText
            primary="Recipient of multiple excellence awards"
          />
        </ListItem>

        <ListItem>
          <ListItemIcon>
            <CheckCircleIcon style={{ color: "#9C27B0" }} />
          </ListItemIcon>
          <ListItemText
            primary="Regular contributor to international medical journals"
          />
        </ListItem>
      </List> */}
    </motion.div>
  );
};

export default Experience;
